"use client";

import { cn } from "@/lib/utils";

interface Props {
  hasElevator: boolean;
  floor: number;
  carryHelp?: boolean;
  floorPlaceholder?: string;
  onElevatorChange: (has: boolean) => void;
  onFloorChange: (floor: number) => void;
  onCarryHelpChange?: (help: boolean) => void;
}

export default function Step2ElevatorSelect({
  hasElevator,
  floor,
  carryHelp,
  floorPlaceholder = "물품을 수거/배송할 층을 선택해주세요",
  onElevatorChange,
  onFloorChange,
  onCarryHelpChange,
}: Props) {
  return (
    <div className="space-y-3">
      {/* 엘리베이터 유무 */}
      <div className="flex gap-2">
        <button
          type="button"
          onClick={() => onElevatorChange(true)}
          className={cn(
            "flex-1 py-2.5 rounded-lg text-sm font-medium border transition-colors flex items-center justify-center gap-1",
            hasElevator
              ? "bg-[#1A3A5C] text-white border-[#1A3A5C]"
              : "bg-white text-gray-500 border-gray-200 hover:border-gray-300"
          )}
        >
          🛗 엘리베이터 있음
        </button>
        <button
          type="button"
          onClick={() => onElevatorChange(false)}
          className={cn(
            "flex-1 py-2.5 rounded-lg text-sm font-medium border transition-colors flex items-center justify-center gap-1",
            !hasElevator
              ? "bg-[#1A3A5C] text-white border-[#1A3A5C]"
              : "bg-white text-gray-500 border-gray-200 hover:border-gray-300"
          )}
        >
          🚶 엘리베이터 없음
        </button>
      </div>

      {/* 층수 선택 (엘리베이터 없을 때만 — 할증 계산용) */}
      {!hasElevator && (
        <div className="space-y-2 animate-in slide-in-from-top-2 duration-200">
          <div className="bg-amber-50 border border-amber-200 rounded-lg px-3 py-2">
            <p className="text-xs text-amber-800 font-medium leading-relaxed">
              1층이어도 차량에서 운반 위치까지 계단이 있을 경우 층 개수에 맞춰 계단층수를 선택해주세요.
            </p>
          </div>
          <div className="flex items-center gap-3">
          <label className="text-sm text-gray-600 whitespace-nowrap">계단 층수</label>
          <select
            value={floor}
            onChange={(e) => onFloorChange(Number(e.target.value))}
            className="flex-1 px-3 py-2.5 border border-gray-200 rounded-lg text-sm
                       bg-white focus:outline-none focus:ring-2 focus:ring-[#1A3A5C]"
          >
            <option value={-99} disabled>{floorPlaceholder}</option>
            <option value={-1}>지하1층</option>
            <option value={1}>1층(계단 10개 이하)</option>
            <option value={2}>2층</option>
            <option value={3}>3층</option>
            <option value={4}>4층</option>
            <option value={5}>5층</option>
            <option value={0}>계단 없음</option>
          </select>
          </div>
        </div>
      )}
      {/* 운반 도움 가능 */}
      {onCarryHelpChange && (
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            checked={carryHelp || false}
            onChange={(e) => onCarryHelpChange(e.target.checked)}
            className="rounded border-gray-300"
          />
          <span className="text-sm text-gray-600">운반 도움 가능</span>
        </label>
      )}
    </div>
  );
}
